import { StoreShippingType } from 'types/storeShipping'

export const FETCH_STORE_SHIPPINGS = 'FETCH_STORE_SHIPPINGS'
export const fetchStoreShippingsAction = (storeShippings: StoreShippingType[]) => {
  return {
    type: 'FETCH_STORE_SHIPPINGS',
    payload: storeShippings,
  }
}

export const INIT_STORE_SHIPPINGS = 'INIT_STORE_SHIPPINGS'
export const initStoreShippingsAction = () => {
  return {
    type: 'INIT_STORE_SHIPPINGS',
    payload: undefined,
  }
}

export const SET_STORE_SHIPPING_UNSUBSCRIBES = 'SET_STORE_SHIPPING_UNSUBSCRIBES'
export const setStoreShippingUnsubscribesAction = (unsubscribes: Array<() => void>) => {
  return {
    type: 'SET_STORE_SHIPPING_UNSUBSCRIBES',
    payload: unsubscribes,
  }
}

export const INIT_STORE_SHIPPING_UNSUBSCRIBES = 'INIT_STORE_SHIPPING_UNSUBSCRIBES'
export const initStoreShippingUnsubscribesAction = () => {
  return {
    type: 'INIT_STORE_SHIPPING_UNSUBSCRIBES',
    payload: undefined,
  }
}
